import { useMemo } from 'react';

import isEmpty from 'lodash/isEmpty';

import { useStores } from '../../../stores/useStores';
import type { SnappyGiftWidgetDataType, WidgetEntry } from '../types';

export function useSnappyGiftWidgets() {
  const { userSnappyGiftsStore } = useStores();
  const { userSnappyGiftsData } = userSnappyGiftsStore;

  const snappyGiftWidgets: SnappyGiftWidgetDataType[] = useMemo(() => {
    if (!isEmpty(userSnappyGiftsData)) {
      return userSnappyGiftsData.map((snappyGift) => ({
        key: snappyGift.id,
        type: 'snappyGift',
        event: snappyGift,
        dataTestId: 'user-snappy-gifts-widget',
      }));
    }

    return [];
  }, [userSnappyGiftsData]);

  return useMemo(
    () => snappyGiftWidgets.map((data): WidgetEntry<'snappyGift'> => ({ data, type: 'snappyGift', id: data.key })),
    [snappyGiftWidgets],
  );
}
